import { useState, useEffect, useCallback } from 'react'
import { getTrips } from '../services/Api';
import { Empty, Flex, Pagination, Spin } from "antd";
import { useNavigate } from 'react-router-dom';

const UserTrips = () => {
    const navigate = useNavigate();
    const [status, setStatus] = useState('pending');
    const [trips, setTrips] = useState([]);
    const [activeTab, setActiveTab] = useState('pending');
    const token = localStorage.getItem('token');
    const [searchValue, setSearchValue] = useState('')
    const [currentPage, setCurrentPage] = useState(1);
    const [total, setTotal] = useState(0);
    const [pageSize, setPageSize] = useState(10);
    const [isLoading, setIsLoading] = useState(false)

    const handlePageChange = (page) => {
        setCurrentPage(page)
    }

    const handleStatus = (status) => {
        setTrips([])
        setStatus(status)
        setActiveTab(status)
    }

    const getAllTrips = useCallback(() => {
        setIsLoading(true);
        getTrips(null, null, status, searchValue, pageSize, currentPage)
            .then((res) => {
                setTrips(res.data.data);
                console.log(res.data.data)
                setTotal(res.data.total);
                setIsLoading(false);
            })
            .catch(() => {
                setIsLoading(false);
            });
    }, [status, searchValue, pageSize, currentPage]);

    useEffect(() => {
        getAllTrips();
    }, [token, getAllTrips]);

    return (
        <>
            <div className="space-y-5 px-5 py-5">
                <div className="block sm:flex justify-between items-center">
                    <div className="space-y-1">
                        <h1 className="text-2xl font-semibold tracking-tight text-[#3A4352]">Dashboard</h1>
                        <div className="text-xs sm:text-sm text-muted-foreground">
                            <span className=' font-semibold text-[#3A4352]'>User Trips</span>
                        </div>
                    </div>
                    <div className="relative w-64 mt-5 sm:mt-0">
                        <input
                            className="px-3 h-10 rounded-md bg-[#F0F0F0] outline-none"
                            placeholder="Search"
                            type="search"
                            onChange={(e) => setSearchValue(e.target.value)}
                        />
                    </div>
                </div>
                <div className=" bg-[#FFF8E2]">
                    <nav className="flex gap-4" aria-label="Tabs">
                        {/* 'pending', 'approved', 'cancelled', 'started', 'completed' */}
                        <button className={`px-3 py-2 text-xs sm:text-sm font-medium text-[#828282] ${activeTab === 'pending' ? 'border-b-2 border-[#E53935] text-[#E53935] font-bold' : ''}`} onClick={() => handleStatus('pending')}>
                            New Trips
                        </button>
                        <button className={`px-3 py-2 text-xs sm:text-sm font-medium text-[#828282] ${activeTab === 'approved' ? 'border-b-2 border-[#E53935] text-[#E53935] font-bold' : ''}`} onClick={() => handleStatus('approved')}>
                            Approved
                        </button>
                        <button className={`px-3 py-2 text-xs sm:text-sm font-medium text-[#828282] ${activeTab === 'completed' ? 'border-b-2 border-[#E53935] text-[#E53935] font-bold' : ''}`} onClick={() => handleStatus('completed')}>
                            Completed
                        </button>
                        <button className={`px-3 py-2 text-xs sm:text-sm font-medium text-[#828282] ${activeTab === 'cancelled' ? 'border-b-2 border-[#E53935] text-[#E53935] font-bold' : ''}`} onClick={() => handleStatus('cancelled')}>
                            Cancelled
                        </button>
                    </nav>
                </div>
                {isLoading ?
                    <div className='mt-20 flex justify-center items-center'>
                        <Flex gap="middle" vertical>
                            <Spin tip="Loading" size="large">
                                <div className='p-12 rounded-xl'></div>
                            </Spin>
                        </Flex>
                    </div>
                    : (
                        trips.length > 0 ? (
                            <>
                                <div className="border rounded-lg overflow-x-auto ">
                                    <table className="w-full">
                                        <thead>
                                            <tr className=" bg-muted/50 bg-[#FFF0F2] ">
                                                <th className="min-w-[70px] text-center text-[#394253] py-3 px-4 text-xs sm:text-sm font-semibold border-r-2 rounded-s-lg">S.No</th>
                                                <th className="min-w-[100px] text-center text-[#394253] py-3 px-4 text-xs sm:text-sm font-semibold border-r-2">Mobile</th>
                                                <th className=" min-w-[170px] text-center text-[#394253] py-3 px-4 text-xs sm:text-sm font-semibold border-r-2">PickUp Location</th>
                                                <th className=" min-w-[170px] text-center text-[#394253] py-3 px-4 text-xs sm:text-sm font-semibold border-r-2">DropOff Location</th>
                                                <th className=" min-w-[70px] text-center text-[#394253] py-3 px-4 text-xs sm:text-sm font-semibold border-r-2">Trip Fare</th>
                                                <th className=" min-w-[70px] text-center text-[#394253] py-3 px-4 text-xs sm:text-sm font-semibold rounded-e-lg">Category</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {trips.map((trip, index) => (
                                                <tr key={index} className="border-b last:border-0" onClick={() => navigate('/admin/tripdetails', { state: { tripId: trip?._id } })}>
                                                    <td className="min-w-[70px] py-3 px-4 text-xs sm:text-sm text-[#62ABF4] text-center cursor-pointer" >{(index + 1)}</td>
                                                    <td className="min-w-[110px] py-3 px-4 text-xs sm:text-sm text-center text-[#394253] cursor-pointer" >{trip?.contact_on || "--"}</td>
                                                    <td className="min-w-[100px] py-3 px-4 text-xs sm:text-sm text-center text-[#394253] cursor-pointer" ><p className=' line-clamp-2'>{trip?.pickUpLocation || "--"}</p></td>
                                                    <td className="min-w-[100px] py-3 px-4 text-xs sm:text-sm text-center text-[#394253] cursor-pointer" ><p className=' line-clamp-2'>{trip?.dropOffLocation || "--"}</p></td>
                                                    <td className="min-w-[100px] py-3 px-4 text-xs sm:text-sm text-center text-[#394253] cursor-pointer" >{trip?.total_trip_fare || "--"}</td>
                                                    <td className="min-w-[170px] py-3 px-4 text-xs sm:text-sm text-center text-[#394253] cursor-pointer" >{trip?.vehicleType?.category || "--"}</td>
                                                </tr>
                                            ))}
                                        </tbody>
                                    </table>
                                </div>
                                <Pagination
                                    align="end"
                                    current={currentPage}
                                    total={total}
                                    pageSize={pageSize}
                                    defaultCurrent={1}
                                    showSizeChanger
                                    pageSizeOptions={['10', '20', '50', '100']}
                                    onChange={handlePageChange}
                                    onShowSizeChange={(page, size) => {
                                        setPageSize(size);
                                        setCurrentPage(1);
                                    }}
                                />
                            </>) : (<Empty />)
                    )}
            </div>
        </>
    )
}
export default UserTrips;